import React from 'react'
import styles from './style.module.css'

const About: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <p className={styles.about}>
      {children}
    </p>
  )
}

export {
  About
}